"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filters_1 = require("./filters");
var immutable_1 = require("immutable");
var deepMerge_1 = require("./deepMerge");
var isValidField = function (values, key) {
    return values
        .every(function (value, i) {
        var prev = values.get(i - 1);
        var match = !i || typeof value === typeof prev;
        if (!match) {
            console.error("Filter \"" + key + "\" has mixed values: [" + values
                .map(filters_1.getFacetType)
                .join(', ') + "\n        ]");
        }
        return match;
    });
};
exports.getChangedFields = function (prev, next) {
    if (next && immutable_1.isImmutable(next) ? next.equals(prev) : next === prev)
        return false;
    if (!prev || !immutable_1.isImmutable(next))
        return next;
    if (!next || next.isEmpty())
        return next;
    return deepMerge_1.default(prev, next).reduce(function (acc, value, key) {
        if (!next.has(key))
            return acc.set(key, null);
        if (prev.has(key) && prev.get(key).equals(value))
            return acc;
        if (immutable_1.List.isList(value) && !isValidField(value.filter(function (v) { return v; }), key))
            return acc;
        return acc.set(key, value);
    }, immutable_1.Map());
};
//# sourceMappingURL=changes.js.map